import * as CONST from '../ActionTypes';

const initialState = {
  documentList: [],
  document: {},
  query: {
    currentPage: 1,
    itemsPerPage: 10,
    sort: 'created_at',
    isAsc: false,
    columnTitle: '',
  },
  totalPages: 1,
};

function document(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // ルールグループ一覧取得
    // -----------------
    case CONST.GET_DOCUMENT_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          documentList: action.payload.assetList,
          totalPages: action.payload.pageNum,
        },
      );
    case CONST.GET_DOCUMENT_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          documentList: [],
        },
      );
    // queryパラメータの設定
    // -----------------
    case CONST.SET_DOCUMENT_QUERY:
      return Object.assign(
        {},
        state,
        {
          query: Object.assign(
            {},
            state,
            action.payload,
          ),
        },
      );
    default:
      return state;
  }
}

export default document;
